import { useEffect, React, useState } from "react";
import { useAuthContext } from "../hooks/useContext/useAuthContext";
import DashboardNavBar from "../components/NavBar/DashboardNavBar";
import Footer from "../components/Shared/Footer";
import { DataGrid } from '@mui/x-data-grid';
import { styled } from '@mui/system';
// import { Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { useAllOrdersContext } from "../hooks/useContext/useAllOrdersContext";
import { useTheme } from "@mui/material/styles";

const GridContainerMain = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.background,
  minHeight: "100vh",
  paddingLeft: "80px",
  paddingRight: "80px",
  paddingTop: "70px",
  marginRight: 'auto',
  paddingBottom: "50px",
  "@media (max-width: 960px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingTop: "35px",
    marginRight: 'auto',
  },
}));


const AllOrders = ({socket}) => {
  const { user } = useAuthContext();
  const [rows, setRows] = useState([]);
  const { allOrders, allOrdersDispatch } = useAllOrdersContext();
  const theme = useTheme();

  //initial fetch all orders
  useEffect(() => {
    const fetchAllOrders = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_SERVER_URL + "/api/orders", {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        });
        const json = await response.json();
        if (response.ok) {
          console.log(json);
          allOrdersDispatch({ type: "SET_ALL_ORDERS", payload: json });
        } else {
          window.location.reload();
        }
      } catch (error) {
        console.error("Error fetching topics:", error);
      }
    };

    if (user) {
      fetchAllOrders();
    }
  }, [allOrdersDispatch, user]);


  //fecth new orders on socket event
  useEffect(() => {
    // console.log('dashboard socket: ' + socket);
    const fetchNewOrders = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_SERVER_URL + "/api/orders/", {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        });
        const json = await response.json();
        if (response.ok) {
          console.log(json);
          allOrdersDispatch({ type: "SET_ALL_ORDERS", payload: json });
        } else {
          window.location.reload();
        }
      } catch (error) {
        console.error("Error fetching topics:", error);
      }
    };

    //data is the returning url from server
    // const handleTopicId = (data) => {
    const handleTopicId = () => {
      fetchNewOrders();
      // console.log(`Received order._id: ${data}`);
    };

    socket.on('newOrder', handleTopicId);
    return () => {
      socket.off('newOrder', handleTopicId);
    };
  }, [user, allOrders, allOrdersDispatch, socket]);


  useEffect(() => {
    if (allOrders && Array.isArray(allOrders)) {
      const updatedRows = allOrders.map((item) => ({
        id: item._id,
        orderPrice: item.totalPrice,
        orderItemsDetails: item.orderItems
          .map(
            (oi) =>
              `${oi.itemName} - Ilość: ${oi.itemQuantity}${
                oi.itemSize !== "Jeden rozmiar" ? ` Size: ${oi.itemSize}` : ""
              }`
          )
          .join(", "),
        orderItems: item.orderItems.length,
        orderTime: item.createdAt,
        orderStatus: item.status,
        orderPaidStatus: item.paidStatus,
        orderName: item.name,
        orderEmail: item.email,
      }));
      setRows(updatedRows);
    }
  }, [allOrders]);
  
  // // set up socket rooms for active topics
  // useEffect(() => {
  //   // Function to join a socket room for a given topic ID
  //   const joinSocketRoom = (roomId) => {
  //     socket.emit('joinRoom', roomId);
  //   };
  
  //   // Function to leave a socket room for a given topic ID
  //   const leaveSocketRoom = (roomId) => {
  //     socket.emit('leaveRoom', roomId);
  //   };
  
  //   // Join socket rooms on component mount and when filteredTopics change
  //   filteredTopics &&
  //   filteredTopics.forEach((topic) => {
  //     if (topic.runningScript) {
  //       joinSocketRoom(topic._id);
  //     }
  //   });
  
  //   // Clean up: Leave socket rooms on component unmount
  //   return () => {
  //     // Leave all socket rooms when the component unmounts
  //     filteredTopics &&
  //       filteredTopics.forEach((topic) => {
  //         if (topic.runningScript) {
  //           leaveSocketRoom(topic._id);
  //         }
  //       });
  //   };
  // }, [socket, filteredTopics]);



  const columns = [
    { 
      field: 'orderTime',
      headerName: 'Czas',
      width: 140,
      valueGetter: (params) => {
        const date = new Date(params.value);
        return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }) + ', ' + date.toLocaleTimeString([], { hourCycle: 'h23', hour: '2-digit', minute:'2-digit'});
      },
    },
    { 
      field: 'orderPrice',
      headerName: 'Cena',
      width: 100, 
      renderCell: (params) => (
        <span>
          {`${params.value} zł`}
        </span>
      ),
    },
    { 
      field: 'orderName',
      headerName: 'Imię',
      width: 140, 
      renderCell: (params) => (
        <span>
          {params.value}
        </span>
      ),
    },
    { 
      field: 'orderPaidStatus',
      headerName: 'Status płatności',
      width: 100, 
      renderCell: (params) => (
        <span>
          {params.value ? 'Zapłacone' : 'Niezapłacone'}
        </span>
      ),
    },
    { 
      field: 'orderItems',
      headerName: 'Items',
      width: 100, 
      renderCell: (params) => (
        <span>{`${params.value} ${params.value === 1 ? 'item' : 'items'}`}</span>
      ),
    },
    { 
      field: 'orderItemsDetails',
      headerName: 'Szczegóły',
      width: 400,
      renderCell: (params) => (
        <Tooltip title={params.value} placement="top-start" arrow>
          <span>{params.value}</span>
        </Tooltip>
      )
    },
    { 
      field: 'orderStatus',
      headerName: 'Status',
      width: 150, 
      renderCell: (params) => (
        <span>
          {params.value === 'Pending' ? 'Oczekujące' : 'Zakończone'}
        </span>
      ),
    },
    { 
      field: 'orderEmail',
      headerName: 'Email',
      width: 300, 
      renderCell: (params) => (
        <span>
          {params.value}
        </span>
      ),
    },
  ];

  return (
    <div style={{backgroundColor: theme.palette.common.background}}>
      <DashboardNavBar />

      <GridContainerMain>
        <div className="Container">
          <div className="Grid">
            {/* <DataGrid rows={usersArticles ? usersArticles : []} columns={columns} /> */}
            <DataGrid rows={rows} columns={columns} />
          </div>
        </div>
      </GridContainerMain>

      <Footer />
    </div>
  );
};

export default AllOrders;